import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=ffb696a4&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=ffb696a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb696a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffb696a4')) {
      api.createRecord('ffb696a4', component.options)
    } else {
      api.reload('ffb696a4', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=ffb696a4&scoped=true&", function () {
      api.rerender('ffb696a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4JxB9d7E10Hv5/JS/comp/PopupDialog.vue"
export default component.exports